
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { profileService } from '@/services';
import { UserProfile } from '@/services/ProfileService';

export const useProfileMutation = (userId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, updates }: { userId: string, updates: Partial<UserProfile> }) => {
      // Direct XP update
      return profileService.updateUserProfile(userId, updates);
    },
    onSuccess: () => {
      if (userId) {
        queryClient.invalidateQueries({ queryKey: ['profile', userId] });
      }
    },
  });
};
